import { connect } from 'react-redux';
import { getRadio } from 'statsradio/modules/authentication/session/reducers/sessionReducer';
import Radio from 'common/domain/radio';

type Props = {
  radio?: Radio,
  children?: any,
};

export function SmallMarketAuthorisation(props: Props) {
  const { radio, children } = props;
  if (!radio) {
    return null;
  }

  const isSmallMarket = radio.isInSmallMarket();

  if (isSmallMarket) {
    return null;
  }
  return children;
}

function mapStateToProps(state) {
  return {
    radio: getRadio(state),
  };
}

export default connect(mapStateToProps)(SmallMarketAuthorisation);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authorisation/SmallMarketAuthorisation.js